import ReactGA from 'react-ga4';
import { hasAnalyticsConsent } from './consent';

// Guard: only fire GA events when the user gave consent
const canTrack = () =>
  process.env.REACT_APP_GA_MEASUREMENT_ID && hasAnalyticsConsent();

// Genel event tracking fonksiyonu
export const trackEvent = (action, category, label = null, value = null) => {
  if (canTrack()) {
    ReactGA.event({
      action,
      category,
      label,
      value,
    });
  }
};

// Form submit tracking
export const trackFormSubmission = (formName) => {
  trackEvent('submit', 'Form', formName);
};

// Button click tracking
export const trackButtonClick = (buttonName, section) => {
  trackEvent('click', 'Button', `${section}_${buttonName}`);
};

// İsim önerisi talebi tracking
export const trackNameSuggestionRequest = (questionCount = null) => {
  trackEvent('request', 'Name Suggestion', 'AI Generated', questionCount);
};

// Kullanıcı kaydı tracking
export const trackUserRegistration = (method = 'email') => {
  trackEvent('sign_up', 'User', method);
};

// Kullanıcı girişi tracking
export const trackUserLogin = (method = 'email') => {
  trackEvent('login', 'User', method);
};

// Favori ekleme tracking
export const trackAddToFavorites = (nameId, nameName) => {
  trackEvent('add_to_favorites', 'Name Interaction', nameName);
};

// Favori çıkarma tracking
export const trackRemoveFromFavorites = (nameId, nameName) => {
  trackEvent('remove_from_favorites', 'Name Interaction', nameName);
};

// Dil değişimi tracking
export const trackLanguageChange = (fromLang, toLang) => {
  trackEvent('language_change', 'User Preference', `${fromLang}_to_${toLang}`);
};

// Sayfa süre tracking
export const trackTiming = (category, variable, value, label = null) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'timing_complete', {
      name: variable,
      value: value,
      event_category: category,
      event_label: label
    });
  }
};

// E-commerce tracking (ödeme sistemi için)
export const trackPurchase = (transactionId, value, currency = 'EUR', items = []) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
      items: items
    });
  }
};

// Danışmanlık randevu talebi tracking
export const trackConsultingRequest = (appointmentType) => {
  trackEvent('consulting_request', 'Business', appointmentType);
};

// Hata tracking
export const trackError = (errorMessage, errorLocation) => {
  trackEvent('error', 'Technical', `${errorLocation}: ${errorMessage}`);
};

// ==========================================
// E-Kitap (Ebook) Analytics Event'leri
// ==========================================

// E-kitap detay sayfasi goruntuleme
export const trackEbookView = (ebookId, ebookTitle) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_view', {
      ebook_id: ebookId,
      ebook_title: ebookTitle
    });
  }
};

// Sample PDF onizleme
export const trackEbookSampleView = (ebookId) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_sample_view', {
      ebook_id: ebookId
    });
  }
};

// PayPal ile satin alma basarili
export const trackEbookPurchasePaypal = (ebookId, amountEur) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_purchase_paypal', {
      ebook_id: ebookId,
      amount_eur: amountEur
    });
  }
};

// PayPal'a yonlendirme
export const trackEbookPaypalRedirect = (ebookId) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_paypal_redirect', {
      ebook_id: ebookId
    });
  }
};

// PayPal'dan iptal donusu
export const trackEbookPaypalCancel = (ebookId) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_paypal_cancel', {
      ebook_id: ebookId
    });
  }
};

// E-kitap indirme
export const trackEbookDownload = (ebookId) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_download', {
      ebook_id: ebookId
    });
  }
};

// Filtre/siralama degisikligi
export const trackEbookFilter = (category, sort) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_filter', {
      category: category || 'all',
      sort: sort || 'newest'
    });
  }
};

// Odeme yontemi secimi
export const trackEbookPaymentMethodSelect = (method) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'ebook_payment_method_select', {
      method: method
    });
  }
};

// ==========================================
// User Journey / Funnel Analytics
// ==========================================

// Tool funnel: kullanici bir tool'u baslattiginda
export const trackToolStart = (toolName, details = {}) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'tool_start', {
      tool_name: toolName,
      ...details
    });
  }
};

// Tool funnel: kullanici tool'dan basariyla sonuc aldiginda
export const trackToolComplete = (toolName, details = {}) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'tool_complete', {
      tool_name: toolName,
      ...details
    });
  }
};

// Scroll depth: kullanici sayfayi ne kadar asagi kaydirdi
export const trackScrollDepth = (depth, pagePath = null) => {
  if (canTrack()) {
    ReactGA.gtag('event', 'scroll_depth', {
      depth: depth,
      page_path: pagePath || window.location.pathname
    });
  }
};

// CTA click: CTA butonlarina tiklanma takibi
export const trackCTAClick = (ctaName, pagePath = null, details = {}) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.gtag('event', 'cta_click', {
      cta_name: ctaName,
      page_path: pagePath || window.location.pathname,
      ...details
    });
  }
};